/**
 * AGL SHOPIFY THEME - DATA LAYER STOREFRONT TRACKING
 * 
 * Gestisce tutti gli eventi lato storefront:
 * - view_cart (apertura cart drawer o pagina /cart)
 * - select_item (click su card prodotto in PLP, ricerca o caroselli)
 * - view_item_list (visualizzazione lista prodotti in collezione o ricerca)
 */

(function () {
  window.dataLayer = window.dataLayer || [];

  // --------------------------------------------------------------------------
  // Helper condivisi per filtri, ricerca e liste
  // --------------------------------------------------------------------------
  function getActiveFilters() {
    const activeFilters = [];
    const filterElements = document.querySelectorAll("[data-active-filters] [data-active-filter]");
    filterElements.forEach(function (el) {
      const filterType = el.dataset.filterLabel || "Filter";
      const textSpan = el.querySelector("span:not([aria-hidden])");
      const filterText = textSpan ? textSpan.textContent.trim() : el.textContent.trim();
      if (filterText) {
        activeFilters.push({
          type: filterType,
          value: filterText
        });
      }
    });
    return activeFilters;
  }

  function getSearchParam() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("q") || "";
  }

  function getListName(card) {
    if (window.location.pathname.includes('/search')) {
      return "search results";
    }
    if (card && card.closest('[data-product-carousel]')) {
      return "product carousel";
    }
    const plpTitle = document.querySelector('h1')?.textContent?.trim();
    return plpTitle || "category listing";
  }

  // ==========================================================================
  // 1. EVENTO: view_cart
  // ==========================================================================
  let lastViewCartTime = 0;

  window.pushViewCartDataLayer = function () {
    const now = Date.now();
    if (now - lastViewCartTime < 800) return; // Debounce anti-duplicazione

    const jsonEl = document.querySelector('[data-cart-datalayer-json]');
    if (!jsonEl) return;

    try {
      const cartData = JSON.parse(jsonEl.textContent);
      if (!cartData.items || cartData.items.length === 0) return;

      lastViewCartTime = now;
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_cart",
        ecommerce: {
          currency: cartData.currency || "EUR",
          value: cartData.value || 0,
          items: cartData.items
        }
      });
    } catch (err) {
      console.warn("dataLayer view_cart error:", err);
    }
  };

  // Ascolto apertura Cart Drawer
  document.addEventListener("drawer:opened", function (event) {
    if (event.detail?.drawerId === "CartDrawer") {
      window.pushViewCartDataLayer();
    }
  });

  // Fallback click su pulsanti apertura carrello
  document.addEventListener("click", function (event) {
    const cartTrigger = event.target.closest('[data-drawer-open][aria-controls="CartDrawer"]');
    if (cartTrigger) {
      setTimeout(window.pushViewCartDataLayer, 50);
    }
  });

  // Se atterriamo direttamente su /cart, invia al caricamento
  if (window.location.pathname.includes('/cart')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.pushViewCartDataLayer);
    } else {
      window.pushViewCartDataLayer();
    }
  }

  // ==========================================================================
  // 2. EVENTO: select_item
  // ==========================================================================
  document.addEventListener("click", function (event) {
    const link = event.target.closest("product-card-swiper a[href]");
    if (!link) return;

    const card = link.closest("product-card-swiper");
    if (!card || !card.dataset.datalayerItem) return;

    try {
      const itemData = JSON.parse(card.dataset.datalayerItem);

      // Calcolo indice nella griglia o nel contenitore
      const container = card.closest("[data-product-grid], .swiper-wrapper, ul, .grid") || document;
      const allCards = Array.from(container.querySelectorAll("product-card-swiper"));
      const cardIndex = allCards.indexOf(card) + 1;
      const index = cardIndex > 0 ? cardIndex : 1;

      const listName = getListName(card);
      const activeFilters = getActiveFilters();
      const searchParam = getSearchParam();

      const itemPayload = {
        item_name: itemData.item_name,
        item_id: itemData.item_id,
        item_variant_id: itemData.item_variant_id,
        item_variant: itemData.item_variant,
        item_color: itemData.item_color,
        currency: itemData.currency || "EUR",
        price: itemData.price || 0,
        quantity: 1,
        discount: itemData.discount || 0,
        item_category: itemData.item_category,
        item_category2: itemData.item_category2 || null,
        item_category3: null,
        item_category4: null,
        item_category5: null,
        item_brand: itemData.item_brand || "AGL",
        index: index,
        item_discounted: Boolean(itemData.item_discounted),
        item_list_name: listName
      };

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: [itemPayload]
        },
        filters: activeFilters,
        search: searchParam || null
      });
    } catch (err) {
      console.warn("dataLayer select_item error:", err);
    }
  });

  // ==========================================================================
  // 3. EVENTO: view_item_list
  // ==========================================================================
  let lastViewListTime = 0;

  window.pushViewItemListDataLayer = function () {
    const now = Date.now();
    if (now - lastViewListTime < 600) return; // Debounce anti-duplicazione

    const cards = document.querySelectorAll("[data-product-grid] product-card-swiper");
    if (!cards || cards.length === 0) return;

    const listName = getListName();
    const items = Array.from(cards).map(function (card, idx) {
      let itemData = {};
      try {
        itemData = JSON.parse(card.dataset.datalayerItem || "{}");
      } catch (e) {}

      return {
        item_name: itemData.item_name || "",
        item_id: itemData.item_id || "",
        item_variant_id: itemData.item_variant_id || "",
        item_variant: itemData.item_variant || "",
        item_color: itemData.item_color || "",
        currency: itemData.currency || "EUR",
        price: itemData.price || 0,
        quantity: 1,
        discount: itemData.discount || 0,
        item_category: itemData.item_category || "",
        item_category2: itemData.item_category2 || null,
        item_category3: null,
        item_category4: null,
        item_category5: null,
        item_brand: itemData.item_brand || "AGL",
        index: idx + 1,
        item_discounted: Boolean(itemData.item_discounted),
        item_list_name: listName
      };
    });

    const activeFilters = getActiveFilters();
    const searchParam = getSearchParam();

    lastViewListTime = now;

    // Suddivisione a blocchi di massimo 10 prodotti per evitare troncamento payload
    const chunkSize = 10;
    for (let i = 0; i < items.length; i += chunkSize) {
      const chunk = items.slice(i, i + chunkSize);
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          items: chunk
        },
        filters: activeFilters,
        search: searchParam || null
      });
    }
  };

  // Invio al caricamento iniziale della pagina
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      if (document.querySelector("[data-product-grid] product-card-swiper")) {
        window.pushViewItemListDataLayer();
      }
    });
  } else {
    if (document.querySelector("[data-product-grid] product-card-swiper")) {
      window.pushViewItemListDataLayer();
    }
  }

  // Invio quando i filtri o la griglia vengono aggiornati via AJAX
  document.addEventListener("collection:updated", function () {
    setTimeout(window.pushViewItemListDataLayer, 100);
  });

  // ==========================================================================
  // 4. EVENTO: newsletter_subscription & Gestione SHA-256 e Challenge
  // ==========================================================================
  const PENDING_NEWSLETTER_KEY = "agl_pending_newsletter_subscription";

  // Algoritmo SHA-256 in JavaScript puro come fallback se Web Crypto non fosse disponibile
  function jsSHA256(ascii) {
    function rightRotate(value, amount) {
      return (value >>> amount) | (value << (32 - amount));
    }
    const mathPow = Math.pow;
    const maxWord = mathPow(2, 32);
    let result = "";
    const words = [];
    const asciiBitLength = ascii.length * 8;
    let hash = [];
    const k = [];
    let primeCounter = 0;

    const isPrime = {};
    for (let candidate = 2; primeCounter < 64; candidate++) {
      if (!isPrime[candidate]) {
        for (let i = candidate * 2; i <= 311; i += candidate) {
          isPrime[i] = true;
        }
        if (primeCounter < 8) {
          hash[primeCounter] = (mathPow(candidate, 0.5) * maxWord) | 0;
        }
        k[primeCounter] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
        primeCounter++;
      }
    }

    ascii += "\x80";
    while ((ascii.length % 64) - 56) ascii += "\x00";
    for (let i = 0; i < ascii.length; i++) {
      const j = ascii.charCodeAt(i);
      words[i >> 2] |= j << ((3 - (i % 4)) * 8);
    }
    words[words.length] = (asciiBitLength / maxWord) | 0;
    words[words.length] = asciiBitLength | 0;

    for (let j = 0; j < words.length;) {
      const w = words.slice(j, (j += 16));
      const oldHash = hash.slice(0);
      for (let i = 0; i < 64; i++) {
        const w15 = w[i - 15], w2 = w[i - 2];
        const s0 = rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3);
        const s1 = rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10);
        w[i] = i < 16 ? w[i] : (((w[i - 16] + s0) | 0) + ((w[i - 7] + s1) | 0)) | 0;

        const s1Round = rightRotate(hash[4], 6) ^ rightRotate(hash[4], 11) ^ rightRotate(hash[4], 25);
        const ch = (hash[4] & hash[5]) ^ (~hash[4] & hash[6]);
        const temp1 = ((((hash[7] + s1Round) | 0) + ch | 0) + ((k[i] + w[i]) | 0)) | 0;
        const s0Round = rightRotate(hash[0], 2) ^ rightRotate(hash[0], 13) ^ rightRotate(hash[0], 22);
        const maj = (hash[0] & hash[1]) ^ (hash[0] & hash[2]) ^ (hash[1] & hash[2]);
        const temp2 = (s0Round + maj) | 0;

        hash = [(temp1 + temp2) | 0, hash[0], hash[1], hash[2], (hash[3] + temp1) | 0, hash[4], hash[5], hash[6]];
      }
      for (let i = 0; i < 8; i++) {
        hash[i] = (hash[i] + oldHash[i]) | 0;
      }
    }

    for (let i = 0; i < 8; i++) {
      for (let j = 3; j >= 0; j--) {
        const b = (hash[i] >> (j * 8)) & 255;
        result += (b < 16 ? "0" : "") + b.toString(16);
      }
    }
    return result;
  }

  // Calcolo SHA-256 (Web Crypto API con fallback robusto)
  async function computeSHA256(str) {
    const normalized = (str || "").trim().toLowerCase();
    if (!normalized) return null;

    if (window.crypto && window.crypto.subtle && window.TextEncoder) {
      try {
        const msgUint8 = new TextEncoder().encode(normalized);
        const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(function (b) {
          return b.toString(16).padStart(2, "0");
        }).join("");
      } catch (e) {
        console.warn("crypto.subtle SHA-256 failed, using fallback:", e);
      }
    }

    return jsSHA256(normalized);
  }

  // Recupero customer_id dal contesto globale o dal primo evento context_info
  function getCustomerId() {
    if (window.aglCustomerId) return String(window.aglCustomerId);
    if (Array.isArray(window.dataLayer)) {
      for (let i = 0; i < window.dataLayer.length; i++) {
        const item = window.dataLayer[i];
        if (item && item.event === "context_info" && item.customer_id) {
          return String(item.customer_id);
        }
      }
    }
    return null;
  }

  // Push evento newsletter_subscription nel dataLayer
  window.pushNewsletterSubscriptionDataLayer = async function (params) {
    const email = params?.email;
    if (!email) return;

    try {
      const emailSHA256 = await computeSHA256(email);
      const customerId = getCustomerId();
      const location = params?.formLocation || "landing";

      window.dataLayer.push({
        event: "newsletter_subscription",
        form_location: location,
        customer_id: customerId,
        emailSHA256: emailSHA256,
        hash_method: "SHA256"
      });
    } catch (err) {
      console.warn("dataLayer newsletter_subscription error:", err);
    }
  };

  // Salvataggio temporaneo in sessionStorage per gestire il redirect reCAPTCHA /challenge
  window.savePendingNewsletterSubscription = function (email, formLocation) {
    if (!email) return;
    try {
      sessionStorage.setItem(
        PENDING_NEWSLETTER_KEY,
        JSON.stringify({
          email: email.trim().toLowerCase(),
          form_location: formLocation || "landing",
          timestamp: Date.now()
        })
      );
    } catch (e) {
      console.warn("sessionStorage save error:", e);
    }
  };

  window.clearPendingNewsletterSubscription = function () {
    try {
      sessionStorage.removeItem(PENDING_NEWSLETTER_KEY);
    } catch (e) {}
  };

  function getPendingNewsletterSubscription() {
    try {
      const raw = sessionStorage.getItem(PENDING_NEWSLETTER_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      // Validità massima 30 minuti
      if (Date.now() - (data.timestamp || 0) > 30 * 60 * 1000) {
        window.clearPendingNewsletterSubscription();
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  // Controllo automatico post-challenge / post-redirect Shopify
  let pendingProcessed = false;
  async function checkPendingNewsletterRedirect() {
    if (pendingProcessed) return;

    const urlParams = new URLSearchParams(window.location.search);
    const isCustomerPosted = urlParams.get("customer_posted") === "true";
    const hasPostedEl = document.querySelector("[data-signup-result][data-posted]") !== null;

    if (!isCustomerPosted && !hasPostedEl) return;

    const pending = getPendingNewsletterSubscription();
    if (!pending || !pending.email) return;

    pendingProcessed = true;
    window.clearPendingNewsletterSubscription();

    await window.pushNewsletterSubscriptionDataLayer({
      email: pending.email,
      formLocation: pending.form_location
    });
  }

  // Verifica all'inizializzazione dello script e su DOMContentLoaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkPendingNewsletterRedirect);
  } else {
    checkPendingNewsletterRedirect();
  }

})();
